// src/pages/RedirectToPayment.js
import React, { useEffect, useState } from 'react';
import PlaneSpinner from './FlightLoadingScreen';

const RedirectToPayment = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'COLLECT_READY') {
        setReady(true);
      }
    };

    window.addEventListener('message', handleMessage);

    // Preload iframe invisibly
    const iframe = document.createElement('iframe');
    iframe.src = '/payment.html';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Safety fallback: if COLLECT never responds, redirect anyway after 4 sec
    const fallback = setTimeout(() => {
      setReady(true);
    }, 4000);

    return () => {
      window.removeEventListener('message', handleMessage);
      clearTimeout(fallback);
      if (iframe && iframe.parentNode) {
        document.body.removeChild(iframe);
      }
    };
  }, []);

  useEffect(() => {
    if (ready) {
      window.location.href = '/payment.html';
    }
  }, [ready]);

  return <PlaneSpinner />;
};

export default RedirectToPayment;
